<template>
    <b-row>
        <div class="col-sm-12 mt-1">
            <h3>
                Editar motivo
            </h3>
        </div>
        <div class="col-sm-8 mt-3">
            <label for="" class="form-label">Motivo</label>
            <input type="text" id="campo_motivo_editar" autocomplete="off" class="form-control form-control-sm"
                v-model="motivo">
        </div>
        <div class="col-sm-4 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="guardar_motivo">Guardar</button>
        </div>
        <div class="col-sm-12 mt-3 mb-3">

        </div>
    </b-row>

</template>

<script>
    import { minix, pregunta } from '@/components/functions/alertas';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'EditarMotivos',
        computed: {
            ...mapState(['motivo_seleccionado'])
        },
        data() {
            return {
                motivo: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            guardar_motivo() {
                if (this.motivo !== '') {
                    let f = {
                        api: `motivo-salidas/${this.motivo_seleccionado.documentId}`,
                        formulario: {
                            motivo: this.motivo.toUpperCase().trim()
                        }
                    }

                    this.actualizar_data(f)
                    this.obtener_motivos_salidas()

                } else {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                    document.getElementById('campo_motivo').focus()
                }

            },
            ...mapActions(['actualizar_data', 'obtener_motivos_salidas'])
        },
        mounted() {
            this.obtener_motivos_salidas()
            this.motivo = this.motivo_seleccionado.motivo
        },
    }
</script>

<style></style>